import { createContext, useContext, useRef } from "react";
const EMPTY_CONFIG = {};
const ConfigContext = createContext(null);
export function useConfigContext() {
    const ctx = useContext(ConfigContext);
    return ctx ?? EMPTY_CONFIG;
}
export function useRuntimeConfig(pageProps) {
    const ref = useRef({});
    const incomingConfig = pageProps?.config ?? EMPTY_CONFIG;
    // Prefers already-known config values over newly provided ones.
    // This is useful when config is loaded once, for example from server-side page props,
    // and should not disappear during client-side navigation or later renders where pageProps.config may be absent.
    ref.current = {
        smartformClientId: ref.current.smartformClientId || incomingConfig.smartformClientId || null,
        gtmId: ref.current.gtmId || incomingConfig.gtmId || null,
        gtmCustomParams: ref.current.gtmCustomParams || incomingConfig.gtmCustomParams || null,
        ga4MeasurementId: ref.current.ga4MeasurementId || incomingConfig.ga4MeasurementId || null,
        metaPixelId: ref.current.metaPixelId || incomingConfig.metaPixelId || null,
        seznamRtgId: ref.current.seznamRtgId || incomingConfig.seznamRtgId || null,
        analyticsEvents: ref.current.analyticsEvents || incomingConfig.analyticsEvents,
    };
    return ref.current;
}
export { ConfigContext };
